import React, { useState, useEffect } from "react";
import { Row, Col, Card, ButtonGroup, Button, Table, Alert, ProgressBar } from "react-bootstrap";
import Utils from "./../../common/Utils";
import axios from "axios";
import _ from "lodash";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

const TeamSummary = (props) => {
  const [filter, setFilter] = useState({ pp: Utils.perpage, st: 0, from: moment().startOf('year').toDate(), to: new Date() });
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  const addFilter = () => {
    let fltr= `?pp=${filter.pp}&st=${filter.st}`;
    fltr += `&from=`+moment(filter.from).format('YYYY-MM-DD');
    fltr += `&to=`+moment(filter.to).format('YYYY-MM-DD');
    return fltr;
  };

  const loadTeamSummary = () => {
    
    setLoading(true);
    axios
      .get(Utils.apiUrl("attendence/teamsummary") + addFilter(), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setTeam(res.data.data);
          setTotal(res.data.total);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(loadTeamSummary, [filter]);

  const showPagination = ( ) => {
    if (loading || (filter.st === 0 && filter.st +  filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {filter.st +  filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`}
                alt="Next"
              />{" "}
              Next
            </div>
          )}
          {filter.st +  filter.pp < total && (
            <div
              className="clickable ms-2 text-clickable"
              onClick={() => setFilter({...filter,st:filter.st+filter.pp})}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-right.png`}
                alt="Next"
              />{" "}
              Next
            </div>
          )}
          {filter.st >= filter.pp && (
            <div
              className="clickable text-clickable"
              onClick={() => setFilter({...filter,st:filter.st-filter.pp})}
            >
              Previous{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-left.png`}
                alt="Previous"
              />
            </div>
          )}
          {filter.st == 0 && (
            <div className="text-disabled">
              Previous{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`}
                alt="Previous"
              />
            </div>
          )}
        </div>
      );
    }
  };

  const getPayHours = (u) => {
    const wdh = _.map(_.split(u.wday_hours,','), parseFloat);
    let d = moment(filter.from);
    let hrs = 0;
    while(wdh && d <= moment(filter.to)){
      if(d.day() < wdh.length && !_.isNaN(wdh[d.day()])){
        hrs+=wdh[d.day()];
      }
      d = d.add(1,'days');
    }
    return hrs;
  }



  return (
    <>
      <Row>
        <Col>
          <h3 className="my-3 title">My Team's Attendance Summary</h3>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Card border="light" className="shadow table-section p-3">
            <Card.Body>
              {/*<Row>
                <Col className="mb-3 d-flex justify-content-end text-right">
                  <ButtonGroup aria-label="Basic example" className="shadow btn-group">
                    <Button
                      variant={filter.tab === 1 ? "primary" : "light"}
                      onClick={() => setFilter({ ...filter, st: 0, tab: 1 })}
                      className="radius-left"
                    >
                      Last 07 days
                    </Button>
                    <Button
                      variant={filter.tab === 2 ? "primary" : "light"}
                      onClick={() => setFilter({ ...filter, st: 0, tab: 2 })}
                      className="radius-right"
                    >
                      Last 30 days
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>*/}

              <Row>
                <Col className="mb-3 d-flex justify-content-end text-right">
                  <div className="d-flex">
                    <DateTimePicker
                      disableClock={true}
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => {
                        if(filter.to < v){
                          alert("To date should be greater than or equal to From date");
                          return;
                        } else{
                          setFilter({...filter, from: v });
                        }
                      }}
                      value={filter.from}
                    />
                    <span className="m-2">To</span>
                    <DateTimePicker
                      disableClock={true}
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => {
                        if(filter.from > v){
                          alert("From date should be less than or equal to To date");
                          return;
                        }else{
                          setFilter({ ...filter, to: v });
                        }
                      }}
                      value={filter.to}
                    />
                  </div>
                </Col>
              </Row>

              {loading && (
                <Alert variant="warning" className="m-0 py-2">
                  <ProgressBar variant="info" animated now={100} />
                </Alert>
              )}

              {!loading && (
                <>
                  <Table striped hover responsive className="text-nowrap">
                    <thead>
                      <tr>
                        <th className="d-table-cell">Sr. No.</th>
                        <th>Name</th>
                        <th>Branch</th>
                        <th className="d-table-cell text-center text-wrap">Differed Time</th>
                        <th className="d-table-cell text-center text-wrap">Paid Extra Hours</th>
                        <th className="d-table-cell text-center text-wrap">Unpaid Hours</th>
                        <th className="d-table-cell text-center text-wrap">TIL Hours</th>
                        <th className="d-table-cell text-center text-wrap">Payroll Hours</th>
                      </tr>
                    </thead>
                    <tbody>
                      {team.map((t, idx) => {
                        return (
                          <tr key={t.id}>
                            <td className="d-table-cell">
                              <span className="tb-lable tb-lable-warning">{Utils.addZero(filter.st + idx + 1)}.</span>
                            </td>
                            <td>
                              {t.title} {t.uname}
                            </td>
                            <td>
                              {t.branch}
                            </td>
                            <td className="d-table-cell text-center">{t.differed}</td>
                            <td className="d-table-cell text-center">{t.paid}</td>
                            <td className="d-table-cell text-center">{t.unpaid}</td>
                            <td className="d-table-cell text-center">{t.lieu}</td>
                            <td className="d-table-cell text-center">{t.payroll}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  {showPagination()}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TeamSummary;
